/**
 * AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.
 * Generated by scripts/generateI18nResources.js
 * Run `pnpm gen:i18n` to regenerate.
 */

import en_accountTypes from '../assets/i18n/en/accountTypes.json';
import en_accountsDetail from '../assets/i18n/en/accountsDetail.json';
import en_accountsReview from '../assets/i18n/en/accountsReview.json';
import en_addClientToHouseholdWizard from '../assets/i18n/en/addClientToHouseholdWizard.json';
import en_addHouseholdMemberWizard from '../assets/i18n/en/addHouseholdMemberWizard.json';
import en_addIdVerificationWizard from '../assets/i18n/en/addIdVerificationWizard.json';
import en_addRelatedEntityWizard from '../assets/i18n/en/addRelatedEntityWizard.json';
import en_advisorContact from '../assets/i18n/en/advisorContact.json';
import en_affiliationTypes from '../assets/i18n/en/affiliationTypes.json';
import en_alertBanners from '../assets/i18n/en/alertBanners.json';
import en_annualSuitabilityReview from '../assets/i18n/en/annualSuitabilityReview.json';
import en_authentication from '../assets/i18n/en/authentication.json';
import en_bankAccountsReview from '../assets/i18n/en/bankAccountsReview.json';
import en_batchRecap from '../assets/i18n/en/batchRecap.json';
import en_buildModels from '../assets/i18n/en/buildModels.json';
import en_bulkImport from '../assets/i18n/en/bulkImport.json';
import en_bulkRebalance from '../assets/i18n/en/bulkRebalance.json';
import en_bulkTrader from '../assets/i18n/en/bulkTrader.json';
import en_client from '../assets/i18n/en/client.json';
import en_clientReportTemplate from '../assets/i18n/en/clientReportTemplate.json';
import en_clients from '../assets/i18n/en/clients.json';
import en_components from '../assets/i18n/en/components.json';
import en_configureModels from '../assets/i18n/en/configureModels.json';
import en_corporations from '../assets/i18n/en/corporations.json';
import en_createAccountWizard from '../assets/i18n/en/createAccountWizard.json';
import en_createGoalWizard from '../assets/i18n/en/createGoalWizard.json';
import en_createSubAccountWizard from '../assets/i18n/en/createSubAccountWizard.json';
import en_customReports from '../assets/i18n/en/customReports.json';
import en_dataWidget from '../assets/i18n/en/dataWidget.json';
import en_devSettings from '../assets/i18n/en/devSettings.json';
import en_document from '../assets/i18n/en/document.json';
import en_driftQueue from '../assets/i18n/en/driftQueue.json';
import en_editHouseholdMemberWizard from '../assets/i18n/en/editHouseholdMemberWizard.json';
import en_employmentInfo from '../assets/i18n/en/employmentInfo.json';
import en_entityMenu from '../assets/i18n/en/entityMenu.json';
import en_entityTypes from '../assets/i18n/en/entityTypes.json';
import en_errorBoundaries from '../assets/i18n/en/errorBoundaries.json';
import en_feeAndBilling from '../assets/i18n/en/feeAndBilling.json';
import en_feePayment from '../assets/i18n/en/feePayment.json';
import en_financialProjection from '../assets/i18n/en/financialProjection.json';
import en_formMapper from '../assets/i18n/en/formMapper.json';
import en_formTypes from '../assets/i18n/en/formTypes.json';
import en_geoNames from '../assets/i18n/en/geoNames.json';
import en_goalsDetails from '../assets/i18n/en/goalsDetails.json';
import en_homePageConfiguration from '../assets/i18n/en/homePageConfiguration.json';
import en_household from '../assets/i18n/en/household.json';
import en_householdFeePaymentModal from '../assets/i18n/en/householdFeePaymentModal.json';
import en_householdSelection from '../assets/i18n/en/householdSelection.json';
import en_institutionsReview from '../assets/i18n/en/institutionsReview.json';
import en_modelFamilies from '../assets/i18n/en/modelFamilies.json';
import en_modelPortfolios from '../assets/i18n/en/modelPortfolios.json';
import en_navMenu from '../assets/i18n/en/navMenu.json';
import en_netWorth from '../assets/i18n/en/netWorth.json';
import en_newsAndInsight from '../assets/i18n/en/newsAndInsight.json';
import en_nonIndividualClients from '../assets/i18n/en/nonIndividualClients.json';
import en_orgSettings from '../assets/i18n/en/orgSettings.json';
import en_pageConfiguration from '../assets/i18n/en/pageConfiguration.json';
import en_paymentInstruction from '../assets/i18n/en/paymentInstruction.json';
import en_portfolioOptimizer from '../assets/i18n/en/portfolioOptimizer.json';
import en_portfolioTemplates from '../assets/i18n/en/portfolioTemplates.json';
import en_portfolioTradingHub from '../assets/i18n/en/portfolioTradingHub.json';
import en_projectedIncomeReport from '../assets/i18n/en/projectedIncomeReport.json';
import en_rebalance from '../assets/i18n/en/rebalance.json';
import en_rebalanceReport from '../assets/i18n/en/rebalanceReport.json';
import en_rebalances from '../assets/i18n/en/rebalances.json';
import en_reconciliation from '../assets/i18n/en/reconciliation.json';
import en_refinitivWidgets from '../assets/i18n/en/refinitivWidgets.json';
import en_relatedEntitySelect from '../assets/i18n/en/relatedEntitySelect.json';
import en_relatedEntityTypes from '../assets/i18n/en/relatedEntityTypes.json';
import en_reports from '../assets/i18n/en/reports.json';
import en_riskProfile from '../assets/i18n/en/riskProfile.json';
import en_ruleFields from '../assets/i18n/en/ruleFields.json';
import en_salesTax from '../assets/i18n/en/salesTax.json';
import en_schedule from '../assets/i18n/en/schedule.json';
import en_settings from '../assets/i18n/en/settings.json';
import en_shared from '../assets/i18n/en/shared.json';
import en_snapshotCard from '../assets/i18n/en/snapshotCard.json';
import en_statementsReview from '../assets/i18n/en/statementsReview.json';
import en_subAccountsDetail from '../assets/i18n/en/subAccountsDetail.json';
import en_subaccount from '../assets/i18n/en/subaccount.json';
import en_taxId from '../assets/i18n/en/taxId.json';
import en_transfer from '../assets/i18n/en/transfer.json';
import en_transferRestriction from '../assets/i18n/en/transferRestriction.json';
import en_trustTypes from '../assets/i18n/en/trustTypes.json';
import en_watchList from '../assets/i18n/en/watchList.json';
import en_workflowCompletions from '../assets/i18n/en/workflowCompletions.json';
import en_workflowReviewFields from '../assets/i18n/en/workflowReviewFields.json';
import es_accountTypes from '../assets/i18n/es/accountTypes.json';
import es_accountsDetail from '../assets/i18n/es/accountsDetail.json';
import es_accountsReview from '../assets/i18n/es/accountsReview.json';
import es_addClientToHouseholdWizard from '../assets/i18n/es/addClientToHouseholdWizard.json';
import es_addHouseholdMemberWizard from '../assets/i18n/es/addHouseholdMemberWizard.json';
import es_addIdVerificationWizard from '../assets/i18n/es/addIdVerificationWizard.json';
import es_addRelatedEntityWizard from '../assets/i18n/es/addRelatedEntityWizard.json';
import es_advisorContact from '../assets/i18n/es/advisorContact.json';
import es_affiliationTypes from '../assets/i18n/es/affiliationTypes.json';
import es_alertBanners from '../assets/i18n/es/alertBanners.json';
import es_annualSuitabilityReview from '../assets/i18n/es/annualSuitabilityReview.json';
import es_authentication from '../assets/i18n/es/authentication.json';
import es_bankAccountsReview from '../assets/i18n/es/bankAccountsReview.json';
import es_batchRecap from '../assets/i18n/es/batchRecap.json';
import es_buildModels from '../assets/i18n/es/buildModels.json';
import es_bulkImport from '../assets/i18n/es/bulkImport.json';
import es_bulkRebalance from '../assets/i18n/es/bulkRebalance.json';
import es_bulkTrader from '../assets/i18n/es/bulkTrader.json';
import es_client from '../assets/i18n/es/client.json';
import es_clientReportTemplate from '../assets/i18n/es/clientReportTemplate.json';
import es_clients from '../assets/i18n/es/clients.json';
import es_components from '../assets/i18n/es/components.json';
import es_configureModels from '../assets/i18n/es/configureModels.json';
import es_corporations from '../assets/i18n/es/corporations.json';
import es_createAccountWizard from '../assets/i18n/es/createAccountWizard.json';
import es_createGoalWizard from '../assets/i18n/es/createGoalWizard.json';
import es_createSubAccountWizard from '../assets/i18n/es/createSubAccountWizard.json';
import es_customReports from '../assets/i18n/es/customReports.json';
import es_dataWidget from '../assets/i18n/es/dataWidget.json';
import es_demo from '../assets/i18n/es/demo.json';
import es_devSettings from '../assets/i18n/es/devSettings.json';
import es_document from '../assets/i18n/es/document.json';
import es_driftQueue from '../assets/i18n/es/driftQueue.json';
import es_editHouseholdMemberWizard from '../assets/i18n/es/editHouseholdMemberWizard.json';
import es_employmentInfo from '../assets/i18n/es/employmentInfo.json';
import es_entityMenu from '../assets/i18n/es/entityMenu.json';
import es_entityTypes from '../assets/i18n/es/entityTypes.json';
import es_errorBoundaries from '../assets/i18n/es/errorBoundaries.json';
import es_feeAndBilling from '../assets/i18n/es/feeAndBilling.json';
import es_feePayment from '../assets/i18n/es/feePayment.json';
import es_financialProjection from '../assets/i18n/es/financialProjection.json';
import es_formMapper from '../assets/i18n/es/formMapper.json';
import es_formTypes from '../assets/i18n/es/formTypes.json';
import es_geoNames from '../assets/i18n/es/geoNames.json';
import es_goalsDetails from '../assets/i18n/es/goalsDetails.json';
import es_homePageConfiguration from '../assets/i18n/es/homePageConfiguration.json';
import es_household from '../assets/i18n/es/household.json';
import es_householdFeePaymentModal from '../assets/i18n/es/householdFeePaymentModal.json';
import es_householdSelection from '../assets/i18n/es/householdSelection.json';
import es_institutionsReview from '../assets/i18n/es/institutionsReview.json';
import es_modelFamilies from '../assets/i18n/es/modelFamilies.json';
import es_modelPortfolios from '../assets/i18n/es/modelPortfolios.json';
import es_navMenu from '../assets/i18n/es/navMenu.json';
import es_netWorth from '../assets/i18n/es/netWorth.json';
import es_newsAndInsight from '../assets/i18n/es/newsAndInsight.json';
import es_nonIndividualClients from '../assets/i18n/es/nonIndividualClients.json';
import es_orgSettings from '../assets/i18n/es/orgSettings.json';
import es_pageConfiguration from '../assets/i18n/es/pageConfiguration.json';
import es_paymentInstruction from '../assets/i18n/es/paymentInstruction.json';
import es_portfolioOptimizer from '../assets/i18n/es/portfolioOptimizer.json';
import es_portfolioTemplates from '../assets/i18n/es/portfolioTemplates.json';
import es_portfolioTradingHub from '../assets/i18n/es/portfolioTradingHub.json';
import es_projectedIncomeReport from '../assets/i18n/es/projectedIncomeReport.json';
import es_rebalance from '../assets/i18n/es/rebalance.json';
import es_rebalanceReport from '../assets/i18n/es/rebalanceReport.json';
import es_rebalances from '../assets/i18n/es/rebalances.json';
import es_reconciliation from '../assets/i18n/es/reconciliation.json';
import es_refinitivWidgets from '../assets/i18n/es/refinitivWidgets.json';
import es_relatedEntitySelect from '../assets/i18n/es/relatedEntitySelect.json';
import es_relatedEntityTypes from '../assets/i18n/es/relatedEntityTypes.json';
import es_reports from '../assets/i18n/es/reports.json';
import es_riskProfile from '../assets/i18n/es/riskProfile.json';
import es_ruleFields from '../assets/i18n/es/ruleFields.json';
import es_salesTax from '../assets/i18n/es/salesTax.json';
import es_schedule from '../assets/i18n/es/schedule.json';
import es_settings from '../assets/i18n/es/settings.json';
import es_shared from '../assets/i18n/es/shared.json';
import es_snapshotCard from '../assets/i18n/es/snapshotCard.json';
import es_statementsReview from '../assets/i18n/es/statementsReview.json';
import es_subAccountsDetail from '../assets/i18n/es/subAccountsDetail.json';
import es_subaccount from '../assets/i18n/es/subaccount.json';
import es_taxId from '../assets/i18n/es/taxId.json';
import es_transfer from '../assets/i18n/es/transfer.json';
import es_transferRestriction from '../assets/i18n/es/transferRestriction.json';
import es_trustTypes from '../assets/i18n/es/trustTypes.json';
import es_watchList from '../assets/i18n/es/watchList.json';
import es_workflowCompletions from '../assets/i18n/es/workflowCompletions.json';
import es_workflowReviewFields from '../assets/i18n/es/workflowReviewFields.json';
import fr_accountTypes from '../assets/i18n/fr/accountTypes.json';
import fr_accountsDetail from '../assets/i18n/fr/accountsDetail.json';
import fr_accountsReview from '../assets/i18n/fr/accountsReview.json';
import fr_addClientToHouseholdWizard from '../assets/i18n/fr/addClientToHouseholdWizard.json';
import fr_addHouseholdMemberWizard from '../assets/i18n/fr/addHouseholdMemberWizard.json';
import fr_addIdVerificationWizard from '../assets/i18n/fr/addIdVerificationWizard.json';
import fr_addRelatedEntityWizard from '../assets/i18n/fr/addRelatedEntityWizard.json';
import fr_advisorContact from '../assets/i18n/fr/advisorContact.json';
import fr_affiliationTypes from '../assets/i18n/fr/affiliationTypes.json';
import fr_alertBanners from '../assets/i18n/fr/alertBanners.json';
import fr_annualSuitabilityReview from '../assets/i18n/fr/annualSuitabilityReview.json';
import fr_authentication from '../assets/i18n/fr/authentication.json';
import fr_bankAccountsReview from '../assets/i18n/fr/bankAccountsReview.json';
import fr_batchRecap from '../assets/i18n/fr/batchRecap.json';
import fr_buildModels from '../assets/i18n/fr/buildModels.json';
import fr_bulkImport from '../assets/i18n/fr/bulkImport.json';
import fr_bulkRebalance from '../assets/i18n/fr/bulkRebalance.json';
import fr_bulkTrader from '../assets/i18n/fr/bulkTrader.json';
import fr_client from '../assets/i18n/fr/client.json';
import fr_clientReportTemplate from '../assets/i18n/fr/clientReportTemplate.json';
import fr_clients from '../assets/i18n/fr/clients.json';
import fr_components from '../assets/i18n/fr/components.json';
import fr_configureModels from '../assets/i18n/fr/configureModels.json';
import fr_corporations from '../assets/i18n/fr/corporations.json';
import fr_createAccountWizard from '../assets/i18n/fr/createAccountWizard.json';
import fr_createGoalWizard from '../assets/i18n/fr/createGoalWizard.json';
import fr_createSubAccountWizard from '../assets/i18n/fr/createSubAccountWizard.json';
import fr_customReports from '../assets/i18n/fr/customReports.json';
import fr_dataWidget from '../assets/i18n/fr/dataWidget.json';
import fr_devSettings from '../assets/i18n/fr/devSettings.json';
import fr_document from '../assets/i18n/fr/document.json';
import fr_driftQueue from '../assets/i18n/fr/driftQueue.json';
import fr_editHouseholdMemberWizard from '../assets/i18n/fr/editHouseholdMemberWizard.json';
import fr_employmentInfo from '../assets/i18n/fr/employmentInfo.json';
import fr_entityMenu from '../assets/i18n/fr/entityMenu.json';
import fr_entityTypes from '../assets/i18n/fr/entityTypes.json';
import fr_errorBoundaries from '../assets/i18n/fr/errorBoundaries.json';
import fr_feeAndBilling from '../assets/i18n/fr/feeAndBilling.json';
import fr_feePayment from '../assets/i18n/fr/feePayment.json';
import fr_financialProjection from '../assets/i18n/fr/financialProjection.json';
import fr_formMapper from '../assets/i18n/fr/formMapper.json';
import fr_formTypes from '../assets/i18n/fr/formTypes.json';
import fr_geoNames from '../assets/i18n/fr/geoNames.json';
import fr_goalsDetails from '../assets/i18n/fr/goalsDetails.json';
import fr_homePageConfiguration from '../assets/i18n/fr/homePageConfiguration.json';
import fr_household from '../assets/i18n/fr/household.json';
import fr_householdFeePaymentModal from '../assets/i18n/fr/householdFeePaymentModal.json';
import fr_householdSelection from '../assets/i18n/fr/householdSelection.json';
import fr_institutionsReview from '../assets/i18n/fr/institutionsReview.json';
import fr_modelFamilies from '../assets/i18n/fr/modelFamilies.json';
import fr_modelPortfolios from '../assets/i18n/fr/modelPortfolios.json';
import fr_navMenu from '../assets/i18n/fr/navMenu.json';
import fr_netWorth from '../assets/i18n/fr/netWorth.json';
import fr_newsAndInsight from '../assets/i18n/fr/newsAndInsight.json';
import fr_nonIndividualClients from '../assets/i18n/fr/nonIndividualClients.json';
import fr_orgSettings from '../assets/i18n/fr/orgSettings.json';
import fr_pageConfiguration from '../assets/i18n/fr/pageConfiguration.json';
import fr_paymentInstruction from '../assets/i18n/fr/paymentInstruction.json';
import fr_portfolioOptimizer from '../assets/i18n/fr/portfolioOptimizer.json';
import fr_portfolioTemplates from '../assets/i18n/fr/portfolioTemplates.json';
import fr_portfolioTradingHub from '../assets/i18n/fr/portfolioTradingHub.json';
import fr_projectedIncomeReport from '../assets/i18n/fr/projectedIncomeReport.json';
import fr_rebalance from '../assets/i18n/fr/rebalance.json';
import fr_rebalanceReport from '../assets/i18n/fr/rebalanceReport.json';
import fr_rebalances from '../assets/i18n/fr/rebalances.json';
import fr_reconciliation from '../assets/i18n/fr/reconciliation.json';
import fr_refinitivWidgets from '../assets/i18n/fr/refinitivWidgets.json';
import fr_relatedEntitySelect from '../assets/i18n/fr/relatedEntitySelect.json';
import fr_relatedEntityTypes from '../assets/i18n/fr/relatedEntityTypes.json';
import fr_reports from '../assets/i18n/fr/reports.json';
import fr_riskProfile from '../assets/i18n/fr/riskProfile.json';
import fr_ruleFields from '../assets/i18n/fr/ruleFields.json';
import fr_salesTax from '../assets/i18n/fr/salesTax.json';
import fr_schedule from '../assets/i18n/fr/schedule.json';
import fr_settings from '../assets/i18n/fr/settings.json';
import fr_shared from '../assets/i18n/fr/shared.json';
import fr_snapshotCard from '../assets/i18n/fr/snapshotCard.json';
import fr_statementsReview from '../assets/i18n/fr/statementsReview.json';
import fr_subAccountsDetail from '../assets/i18n/fr/subAccountsDetail.json';
import fr_subaccount from '../assets/i18n/fr/subaccount.json';
import fr_taxId from '../assets/i18n/fr/taxId.json';
import fr_transfer from '../assets/i18n/fr/transfer.json';
import fr_transferRestriction from '../assets/i18n/fr/transferRestriction.json';
import fr_trustTypes from '../assets/i18n/fr/trustTypes.json';
import fr_watchList from '../assets/i18n/fr/watchList.json';
import fr_workflowCompletions from '../assets/i18n/fr/workflowCompletions.json';
import fr_workflowReviewFields from '../assets/i18n/fr/workflowReviewFields.json';

export const translations = {
  en: {
    accountTypes: en_accountTypes,
    accountsDetail: en_accountsDetail,
    accountsReview: en_accountsReview,
    addClientToHouseholdWizard: en_addClientToHouseholdWizard,
    addHouseholdMemberWizard: en_addHouseholdMemberWizard,
    addIdVerificationWizard: en_addIdVerificationWizard,
    addRelatedEntityWizard: en_addRelatedEntityWizard,
    advisorContact: en_advisorContact,
    affiliationTypes: en_affiliationTypes,
    alertBanners: en_alertBanners,
    annualSuitabilityReview: en_annualSuitabilityReview,
    authentication: en_authentication,
    bankAccountsReview: en_bankAccountsReview,
    batchRecap: en_batchRecap,
    buildModels: en_buildModels,
    bulkImport: en_bulkImport,
    bulkRebalance: en_bulkRebalance,
    bulkTrader: en_bulkTrader,
    client: en_client,
    clientReportTemplate: en_clientReportTemplate,
    clients: en_clients,
    components: en_components,
    configureModels: en_configureModels,
    corporations: en_corporations,
    createAccountWizard: en_createAccountWizard,
    createGoalWizard: en_createGoalWizard,
    createSubAccountWizard: en_createSubAccountWizard,
    customReports: en_customReports,
    dataWidget: en_dataWidget,
    devSettings: en_devSettings,
    document: en_document,
    driftQueue: en_driftQueue,
    editHouseholdMemberWizard: en_editHouseholdMemberWizard,
    employmentInfo: en_employmentInfo,
    entityMenu: en_entityMenu,
    entityTypes: en_entityTypes,
    errorBoundaries: en_errorBoundaries,
    feeAndBilling: en_feeAndBilling,
    feePayment: en_feePayment,
    financialProjection: en_financialProjection,
    formMapper: en_formMapper,
    formTypes: en_formTypes,
    geoNames: en_geoNames,
    goalsDetails: en_goalsDetails,
    homePageConfiguration: en_homePageConfiguration,
    household: en_household,
    householdFeePaymentModal: en_householdFeePaymentModal,
    householdSelection: en_householdSelection,
    institutionsReview: en_institutionsReview,
    modelFamilies: en_modelFamilies,
    modelPortfolios: en_modelPortfolios,
    navMenu: en_navMenu,
    netWorth: en_netWorth,
    newsAndInsight: en_newsAndInsight,
    nonIndividualClients: en_nonIndividualClients,
    orgSettings: en_orgSettings,
    pageConfiguration: en_pageConfiguration,
    paymentInstruction: en_paymentInstruction,
    portfolioOptimizer: en_portfolioOptimizer,
    portfolioTemplates: en_portfolioTemplates,
    portfolioTradingHub: en_portfolioTradingHub,
    projectedIncomeReport: en_projectedIncomeReport,
    rebalance: en_rebalance,
    rebalanceReport: en_rebalanceReport,
    rebalances: en_rebalances,
    reconciliation: en_reconciliation,
    refinitivWidgets: en_refinitivWidgets,
    relatedEntitySelect: en_relatedEntitySelect,
    relatedEntityTypes: en_relatedEntityTypes,
    reports: en_reports,
    riskProfile: en_riskProfile,
    ruleFields: en_ruleFields,
    salesTax: en_salesTax,
    schedule: en_schedule,
    settings: en_settings,
    shared: en_shared,
    snapshotCard: en_snapshotCard,
    statementsReview: en_statementsReview,
    subAccountsDetail: en_subAccountsDetail,
    subaccount: en_subaccount,
    taxId: en_taxId,
    transfer: en_transfer,
    transferRestriction: en_transferRestriction,
    trustTypes: en_trustTypes,
    watchList: en_watchList,
    workflowCompletions: en_workflowCompletions,
    workflowReviewFields: en_workflowReviewFields,
  },
  es: {
    accountTypes: es_accountTypes,
    accountsDetail: es_accountsDetail,
    accountsReview: es_accountsReview,
    addClientToHouseholdWizard: es_addClientToHouseholdWizard,
    addHouseholdMemberWizard: es_addHouseholdMemberWizard,
    addIdVerificationWizard: es_addIdVerificationWizard,
    addRelatedEntityWizard: es_addRelatedEntityWizard,
    advisorContact: es_advisorContact,
    affiliationTypes: es_affiliationTypes,
    alertBanners: es_alertBanners,
    annualSuitabilityReview: es_annualSuitabilityReview,
    authentication: es_authentication,
    bankAccountsReview: es_bankAccountsReview,
    batchRecap: es_batchRecap,
    buildModels: es_buildModels,
    bulkImport: es_bulkImport,
    bulkRebalance: es_bulkRebalance,
    bulkTrader: es_bulkTrader,
    client: es_client,
    clientReportTemplate: es_clientReportTemplate,
    clients: es_clients,
    components: es_components,
    configureModels: es_configureModels,
    corporations: es_corporations,
    createAccountWizard: es_createAccountWizard,
    createGoalWizard: es_createGoalWizard,
    createSubAccountWizard: es_createSubAccountWizard,
    customReports: es_customReports,
    dataWidget: es_dataWidget,
    demo: es_demo,
    devSettings: es_devSettings,
    document: es_document,
    driftQueue: es_driftQueue,
    editHouseholdMemberWizard: es_editHouseholdMemberWizard,
    employmentInfo: es_employmentInfo,
    entityMenu: es_entityMenu,
    entityTypes: es_entityTypes,
    errorBoundaries: es_errorBoundaries,
    feeAndBilling: es_feeAndBilling,
    feePayment: es_feePayment,
    financialProjection: es_financialProjection,
    formMapper: es_formMapper,
    formTypes: es_formTypes,
    geoNames: es_geoNames,
    goalsDetails: es_goalsDetails,
    homePageConfiguration: es_homePageConfiguration,
    household: es_household,
    householdFeePaymentModal: es_householdFeePaymentModal,
    householdSelection: es_householdSelection,
    institutionsReview: es_institutionsReview,
    modelFamilies: es_modelFamilies,
    modelPortfolios: es_modelPortfolios,
    navMenu: es_navMenu,
    netWorth: es_netWorth,
    newsAndInsight: es_newsAndInsight,
    nonIndividualClients: es_nonIndividualClients,
    orgSettings: es_orgSettings,
    pageConfiguration: es_pageConfiguration,
    paymentInstruction: es_paymentInstruction,
    portfolioOptimizer: es_portfolioOptimizer,
    portfolioTemplates: es_portfolioTemplates,
    portfolioTradingHub: es_portfolioTradingHub,
    projectedIncomeReport: es_projectedIncomeReport,
    rebalance: es_rebalance,
    rebalanceReport: es_rebalanceReport,
    rebalances: es_rebalances,
    reconciliation: es_reconciliation,
    refinitivWidgets: es_refinitivWidgets,
    relatedEntitySelect: es_relatedEntitySelect,
    relatedEntityTypes: es_relatedEntityTypes,
    reports: es_reports,
    riskProfile: es_riskProfile,
    ruleFields: es_ruleFields,
    salesTax: es_salesTax,
    schedule: es_schedule,
    settings: es_settings,
    shared: es_shared,
    snapshotCard: es_snapshotCard,
    statementsReview: es_statementsReview,
    subAccountsDetail: es_subAccountsDetail,
    subaccount: es_subaccount,
    taxId: es_taxId,
    transfer: es_transfer,
    transferRestriction: es_transferRestriction,
    trustTypes: es_trustTypes,
    watchList: es_watchList,
    workflowCompletions: es_workflowCompletions,
    workflowReviewFields: es_workflowReviewFields,
  },
  fr: {
    accountTypes: fr_accountTypes,
    accountsDetail: fr_accountsDetail,
    accountsReview: fr_accountsReview,
    addClientToHouseholdWizard: fr_addClientToHouseholdWizard,
    addHouseholdMemberWizard: fr_addHouseholdMemberWizard,
    addIdVerificationWizard: fr_addIdVerificationWizard,
    addRelatedEntityWizard: fr_addRelatedEntityWizard,
    advisorContact: fr_advisorContact,
    affiliationTypes: fr_affiliationTypes,
    alertBanners: fr_alertBanners,
    annualSuitabilityReview: fr_annualSuitabilityReview,
    authentication: fr_authentication,
    bankAccountsReview: fr_bankAccountsReview,
    batchRecap: fr_batchRecap,
    buildModels: fr_buildModels,
    bulkImport: fr_bulkImport,
    bulkRebalance: fr_bulkRebalance,
    bulkTrader: fr_bulkTrader,
    client: fr_client,
    clientReportTemplate: fr_clientReportTemplate,
    clients: fr_clients,
    components: fr_components,
    configureModels: fr_configureModels,
    corporations: fr_corporations,
    createAccountWizard: fr_createAccountWizard,
    createGoalWizard: fr_createGoalWizard,
    createSubAccountWizard: fr_createSubAccountWizard,
    customReports: fr_customReports,
    dataWidget: fr_dataWidget,
    devSettings: fr_devSettings,
    document: fr_document,
    driftQueue: fr_driftQueue,
    editHouseholdMemberWizard: fr_editHouseholdMemberWizard,
    employmentInfo: fr_employmentInfo,
    entityMenu: fr_entityMenu,
    entityTypes: fr_entityTypes,
    errorBoundaries: fr_errorBoundaries,
    feeAndBilling: fr_feeAndBilling,
    feePayment: fr_feePayment,
    financialProjection: fr_financialProjection,
    formMapper: fr_formMapper,
    formTypes: fr_formTypes,
    geoNames: fr_geoNames,
    goalsDetails: fr_goalsDetails,
    homePageConfiguration: fr_homePageConfiguration,
    household: fr_household,
    householdFeePaymentModal: fr_householdFeePaymentModal,
    householdSelection: fr_householdSelection,
    institutionsReview: fr_institutionsReview,
    modelFamilies: fr_modelFamilies,
    modelPortfolios: fr_modelPortfolios,
    navMenu: fr_navMenu,
    netWorth: fr_netWorth,
    newsAndInsight: fr_newsAndInsight,
    nonIndividualClients: fr_nonIndividualClients,
    orgSettings: fr_orgSettings,
    pageConfiguration: fr_pageConfiguration,
    paymentInstruction: fr_paymentInstruction,
    portfolioOptimizer: fr_portfolioOptimizer,
    portfolioTemplates: fr_portfolioTemplates,
    portfolioTradingHub: fr_portfolioTradingHub,
    projectedIncomeReport: fr_projectedIncomeReport,
    rebalance: fr_rebalance,
    rebalanceReport: fr_rebalanceReport,
    rebalances: fr_rebalances,
    reconciliation: fr_reconciliation,
    refinitivWidgets: fr_refinitivWidgets,
    relatedEntitySelect: fr_relatedEntitySelect,
    relatedEntityTypes: fr_relatedEntityTypes,
    reports: fr_reports,
    riskProfile: fr_riskProfile,
    ruleFields: fr_ruleFields,
    salesTax: fr_salesTax,
    schedule: fr_schedule,
    settings: fr_settings,
    shared: fr_shared,
    snapshotCard: fr_snapshotCard,
    statementsReview: fr_statementsReview,
    subAccountsDetail: fr_subAccountsDetail,
    subaccount: fr_subaccount,
    taxId: fr_taxId,
    transfer: fr_transfer,
    transferRestriction: fr_transferRestriction,
    trustTypes: fr_trustTypes,
    watchList: fr_watchList,
    workflowCompletions: fr_workflowCompletions,
    workflowReviewFields: fr_workflowReviewFields,
  },
} as const;

export const namespaces = Object.keys(translations.en);
export const defaultNS = 'base';
